/* Facets — submits the filter form through the Section Rendering API so the
   grid and the rail update in place. Without JS the form still submits normally. */
(function () {
  'use strict';

  var Sloos = window.Sloos || {};

  if (!customElements.get('facet-filters')) {
    customElements.define(
      'facet-filters',
      class FacetFilters extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-facet-form]');
          this.sectionId = this.dataset.sectionId;
          if (!this.form) return;

          this.debouncedSubmit = (Sloos.debounce || function (fn) { return fn; })(this.apply.bind(this), 400);

          this.form.addEventListener('change', function (event) {
            if (event.target.type === 'number') this.debouncedSubmit();
            else this.apply();
          }.bind(this));

          this.form.addEventListener('submit', function (event) {
            event.preventDefault();
            this.apply();
          }.bind(this));

          var clear = this.querySelector('[data-facet-clear]');
          if (clear) {
            clear.addEventListener('click', function (event) {
              event.preventDefault();
              this.render(clear.getAttribute('href'));
            }.bind(this));
          }

          window.addEventListener('popstate', function (event) {
            if (event.state && event.state.facets) this.render(event.state.facets, true);
          }.bind(this));
        }

        apply() {
          var params = new URLSearchParams(new FormData(this.form)).toString();
          var base = this.dataset.resultsUrl;
          var sortInput = document.querySelector('[data-sort-value]');
          if (sortInput && sortInput.value) {
            params = params ? params + '&sort_by=' + encodeURIComponent(sortInput.value) : 'sort_by=' + encodeURIComponent(sortInput.value);
          }
          this.render(params ? base + '?' + params : base);
        }

        render(url, skipHistory) {
          var main = document.getElementById('CollectionResults');
          if (main) main.classList.add('is-busy');

          var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + this.sectionId;

          fetch(fetchUrl)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');

                ['CollectionResults', 'FacetRail', 'CollectionToolbar'].forEach(function (id) {
                  var incoming = doc.getElementById(id);
                  var current = document.getElementById(id);
                  if (incoming && current) current.innerHTML = incoming.innerHTML;
                });

                if (!skipHistory) {
                  window.history.pushState({ facets: url }, '', url);
                }

                if (main) main.classList.remove('is-busy');
                var heading = document.getElementById('CollectionToolbar');
                if (heading) heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }.bind(this)
            )
            .catch(function () {
              /* Network trouble — fall back to a full navigation. */
              window.location.href = url;
            });
        }
      }
    );
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-sort-value]')) return;

    /* The home page grid cannot re-sort itself — it sorts on the collection
       page, so the control carries the URL to go to. */
    var sortUrl = event.target.getAttribute('data-sort-url');
    if (sortUrl) {
      var join = sortUrl.indexOf('?') === -1 ? '?' : '&';
      window.location.href = sortUrl + join + 'sort_by=' + encodeURIComponent(event.target.value);
      return;
    }

    var facets = document.querySelector('facet-filters');
    if (facets) facets.apply();
    else window.location.search = 'sort_by=' + encodeURIComponent(event.target.value);
  });

  /* Removing an active filter takes the same in-place path as changing one. */
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-facet-remove]');
    if (!chip) return;

    var facets = document.querySelector('facet-filters');
    if (!facets) return;

    event.preventDefault();
    facets.render(chip.getAttribute('href'));
  });

  /* Filter rail toggle below 1100px — filters must never push the first
     product below the fold, so the rail collapses there and expands on demand.
     The collapsing itself is CSS's job (.js .facet-panel:not([data-open])),
     because this script is deferred and driving `hidden` from here painted the
     rail open first. All this does is flip data-open and keep aria in step. */
  var NARROW = 1100;

  function panelFor(toggle) {
    var id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function syncPanels() {
    var narrow = window.innerWidth <= NARROW;

    document.querySelectorAll('.facet-panel').forEach(function (panel) {
      /* An older build hid the panel with `hidden`; clear any leftover so the
         attribute can never outlive a resize back to desktop. */
      if (panel.hidden) panel.hidden = false;
      if (panel.dataset.open !== 'true') panel.dataset.open = 'false';
    });

    document.querySelectorAll('[data-facet-toggle]').forEach(function (toggle) {
      var panel = panelFor(toggle);
      if (!panel) return;
      var open = !narrow || panel.dataset.open === 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      var caret = toggle.querySelector('[aria-hidden="true"]');
      if (caret) caret.textContent = open ? '\u2013' : '+';
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-facet-toggle]');
    if (!toggle) return;

    var panel = panelFor(toggle);
    if (!panel) return;

    panel.dataset.open = panel.dataset.open === 'true' ? 'false' : 'true';
    syncPanels();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncPanels, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPanels);
  } else {
    syncPanels();
  }

  document.addEventListener('shopify:section:load', syncPanels);
})();
